import { ContractsModule } from "@/store/contracts.module";
import { Component, Vue } from "vue-property-decorator";

@Component
export class ContractIdValidatorMixin extends Vue {
  async validateContractId() {
    // if target contract is not in the list, go back
    const { id } = this.$route.params;
    const contract = ContractsModule.contracts.find(
      c => c.contract_rid.toString() === id,
    );
    if (!contract) {
      ContractsModule.setSelectedContract(null);
      return this.$router.push("/contracts");
    }
    ContractsModule.setSelectedContract(contract.contract_rid);

    ContractsModule.setinfoIsLoading(true);
    ContractsModule.getContractStatus(id);
    ContractsModule.getContractInfo(id);
  }
}
